import { Component, OnInit, AfterViewInit, ViewChildren } from '@angular/core';
import { FormGroup, FormControl, Validators } from '@angular/forms';
import { AppdataService } from 'src/app/services/services/appdata.service';
import { LoginserviceService } from 'src/app/services/services/loginservice.service';
import { ActivatedRoute, Router } from '@angular/router';
import { ToastrService } from 'ngx-toastr';
import { NgbModal } from '@ng-bootstrap/ng-bootstrap';

@Component({
  selector: 'app-addstatus',
  templateUrl: './addstatus.component.html',
  styleUrls: ['./addstatus.component.css']
})
export class AddstatusComponent implements OnInit ,AfterViewInit {

  @ViewChildren('input')firstipcontrol;

  formname: string = "Status";

//Display
formmode:string="Add";

//Mode Values
isaddmode:boolean=false;
iseditmode:boolean=false;
isdeletemode:boolean=false;
isviewmode:boolean=false;

isloading: boolean = false;
   isprivilage: boolean = false;
   showProgress: boolean = false;   


//Save Validation
submitted:boolean;
successfully:boolean;
saveloading: boolean;

//Edit Get Values
statusColl:any=[];
statusBO:any={};

statusid:number=0

statusform=new FormGroup({
  statusid:new FormControl(0),          
  statusname:new FormControl('',Validators.required),  
 inactive:new FormControl(false),  
});


constructor(private appService: AppdataService,private loginService:LoginserviceService,private route: ActivatedRoute,
   public router: Router,private toastr: ToastrService, private productFindService: NgbModal) { 
     this.route.queryParams.subscribe(params => {
       if(params.id!==undefined){
         this.statusid = params.id
       }          
     });

     this.fnServiceChanges();
}

 
fnServiceChanges() {
  this.loginService.serviceAuthChange.subscribe((value) => {
    if (this.loginService.fnCheckCompany()) {
      if (this.fnCheckUserPririvilage()) {
        this.isloading = true;
        this.fnOnInitForm();
      }
      else {
        this.fnUserFailedForm();
      }
    }
    else {
      this.fnUserFailedForm();
    }

  });
}



ngOnInit() {
  try {
    if (this.loginService.fnCheckCompany()) {
      if (this.fnCheckUserPririvilage()) {
        this.isloading = true;
        this.fnOnInitForm();
      }
      else {
        this.fnUserFailedForm();
      }
    }
    else {
      this.loginService.fnGetUserRoleList();
    }

  } catch (ex) {
    this.fnShowErrorMsg(ex);
  }
}

fnOnInitForm() {  
   try{
       this.isaddmode=true;
       this.statusform.reset();
       this.fnInitializeFormGroup(); 

       if(this.statusid>0){
         this.fngetStatus();
       }
   }catch(ex){
     this.fnShowErrorMsg(ex);
   }
}
fnCheckUserPririvilage() {
  var _check: boolean = false;
  if (this.statusid > 0) {
    _check = this.loginService.fnCheckUserRoleAction(this.formname, 'ALTER')
  } else {
    _check = this.loginService.fnCheckUserRoleAction(this.formname, 'CREATE')
  }

  return _check;
}

fnUserFailedForm() {
  this.isprivilage = true;
}  
ngAfterViewInit()
{
  this.loginService.fnSetFirstControlFocus('txtfirst');
}fnInitializeFormGroup(){
   this.statusform.setValue({
    statusid:0,    
    statusname:'',
     inactive:false              
   })
}

//Get 
fngetStatus() { 
  if (this.showProgress) {
    return;
  }         
     var data = {
       'statusid':this.statusid,
       'companyid':this.loginService.fnGetCompanyId()          
     }
     this.appService.getStatus(data)
     .subscribe(
       (res)=>{                
         if(res.json().status===200){ 
          this.fnHideProgress();
 
           this.statusColl=res.json().result;
           var editdata = this.statusColl[0];        
           this.fnEditMode(editdata);
           this.statusBO=editdata;
         }
         else {
          this.fnHideProgress();

           this.loginService.fnAPIError(res.json())
         }
         
     },
     (err)=>{    
      this.fnHideProgress();
      
       this.toastr.error('Error', err);
     })
}



//Save Btn Click
fnSaveBtnClick(){
   try{
    if (this.saveloading) {
           return;
         }
   
     this.submitted=true;
     this.successfully=false;
     //Validate
     if(this.statusform.valid){ this.saveloading = true;

         //Check
         var data = {
               'statusid': this.statusid,                      
               'statusname':this.statusform.get('statusname').value, 
               'inactive':this.statusform.get('inactive').value,            
               'companyid':this.loginService.fnGetCompanyId(),
               'createdby': this.loginService.fnGetModUserId(),  
              'modifiedby':this.loginService.fnGetModUserId(),                                                              
         }

       
         this.appService.fnCheckStatus(data).subscribe(
           (res)=>{
             if(res.json().status===200){  
               var _checkresult=res.json().result[0].checkfield;
             
               if(_checkresult==="done"){
                     if (this.statusform.get('statusid').value>0){
                       //Update 
                       this.fnSetStatus(data);
                     }
                     else{
                       //Insert 
                       this.fnInsertStatus(data);
                     }
               }
               else{        
                     if(_checkresult==="name"){this.saveloading = false;
                       this.statusform.controls['statusname'].setErrors({'notfound': true});
                     }
               }
             }
             else {this.saveloading = false;
               this.loginService.fnAPIError(res.json())
             }
         },
         (err)=>{this.saveloading = false;
             this.toastr.error('Error', err);           
         });
      }
   }catch(ex){this.saveloading = false;
     this.fnShowErrorMsg(ex);
   }
}

//Insert
fnInsertStatus(data){    
 
   this.appService.fnInsertStatus(data).subscribe(
     (res)=>{this.saveloading = false;
       if(res.json().status===200){  
         if(res.json().result!=""){
           this.toastr.success('', "The new status has been added successfully.Insert Successfully");
           this.fnInsertActivityLog('INSERT', 0, data.statusname);
           this.fnCloseForm();
         }
       }
       else {
         this.loginService.fnAPIError(res.json())
       }
   },
     (err)=>{this.saveloading = false;
       this.toastr.error('Error', err);
     });

}

//Set
fnSetStatus(data){    

this.appService.fnSetStatus(data).subscribe(
 (res)=>{this.saveloading = false;
   if(res.json().status===200){  
         if(res.json().result!=""){
             this.toastr.success('', "The status has been updated successfully.");
             this.fnInsertActivityLog('EDIT',this.statusid,data.statusname);
             this.fnCloseForm();        
         } 
     }
   else {
     this.loginService.fnAPIError(res.json())
   }
 },
 (err)=>{this.saveloading = false;
   this.toastr.error('Error', err);
 });

}

//Close
fnCloseForm(){
try{
  this.router.navigate(['/Status']);
}catch(ex){
   this.fnShowErrorMsg(ex);
}
}

private fnEditMode(deptBO){
 this.statusform.setValue({ 
  statusid:deptBO.statusid,     
  statusname:deptBO.statusname,
   inactive:deptBO.inactive
 });

 this.formmode="Edit";
   
 this.iseditmode=true;
 this.isdeletemode=false;
 this.isviewmode=false;
}
fnInsertActivityLog(action,refno,desc){
  try{
    var data={
      logtype:action,
      logat:this.formname,
      refnum:refno,
      logdescr:desc,companyid: this.loginService.fnGetCompanyId(),         
      logby:this.loginService.fnGetModUserId(),
    }
  

    this.appService.fnInsertActivity(data).subscribe(
      (res)=>{
      },
      (err)=>{
     
      });

  }catch{

  }
}
private fnShowProgress() {
  this.showProgress = true;
}
private fnHideProgress() {
  this.showProgress = false;
} 

private  fnShowErrorMsg(ex){
this.toastr.warning('Internal Error', ex);       
}






}
